import styled from 'styled-components';

export const CopyRight = styled.div`
  padding: 0 40px;
`;
